import { render } from "./new-two-grid-sec-full-bleed.vue?vue&type=template&id=03f20e5e&scoped=true"
import script from "./new-two-grid-sec-full-bleed.vue?vue&type=script&lang=js"
export * from "./new-two-grid-sec-full-bleed.vue?vue&type=script&lang=js"

import "./new-two-grid-sec-full-bleed.vue?vue&type=style&index=0&id=03f20e5e&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f20e5e"]])

export default __exports__